const classList = [
    {
        name: "Fart Yoga",
        type: "yoga",
        start: "7:00 a.m.",
        duration: 30,
        intensity: "low",
        location: "north",
        registered: 1,
        maxsize: 4,
    },
    {
        name: "Cycle Sadness",
        type: "cycle",
        start: "9:00 a.m.",
        duration: 60,
        intensity: "high",
        location: "south",
        registered: 3,
        maxsize: 8
    },
    {
        name: "Boulder Crushing",
        type: "insanity",
        start: "11:00 a.m.",
        duration: 60,
        intensity: "high",
        location: "south",
        registered: 5,
        maxsize: 10
    },
    {
        name: "Pierre's Pilates",
        type: "pilates",
        start: "8:00 a.m.",
        duration: 30,
        intensity: "low",
        location: "west",
        registered: 1,
        maxsize: 6
    },
    {
        name: "GET RIPPED XTREME",
        type: "ripped",
        start: "3:00 p.m.",
        duration: 60,
        intensity: "high",
        location: "east",
        registered: 3,
        maxsize: 8
    },
    {
        name: "Full class",
        type: "class should not be rendered",
        start: "3:00 p.m.",
        duration: 60,
        intensity: "high",
        location: "east",
        registered: 8,
        maxsize: 8
    },

]

export default classList